<template>
    <div class="land-flats active">
        <div class="container">
            <div class="land-section-title" v-if="salesCardPage != null">
                <h2>{{salesCardPage.land_site_section_titles.flats}}</h2>
            </div>
           <flatsFilter></flatsFilter>
		   <flatsCards></flatsCards>
            <!-- <a href="#" @click.prevent="getFlatsData">Получить квартиры</a> -->
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
	import flatsFilter from '@/components/sales-land-partials/flats-partials/flat-filter.vue'
	import flatsCards from '@/components/sales-land-partials/flats-partials/flat-cards.vue'
    export default {
        name: 'sale-land-flats',
        components: {
			flatsFilter,
			flatsCards,
        },
        data () {
            return {
                // for flats filter
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
            salesCardFlats: 'loadFlatsCardsGlobal',
            salesCardFlatsDefault: 'loadFlatsCardsGlobalDefault',
        }),
        methods: {
        },
        beforeCreate() {
            this.$store.dispatch('getFlatsCards', window.host).then((response) => {
               console.log('response complete')
            });
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-flats.scss';
    @import '@/styles/respond/sales/sales-land-partials/land-flats-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>